(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PaymentMethodDeleteController',PaymentMethodDeleteController);

    PaymentMethodDeleteController.$inject = ['$uibModalInstance', 'entity', 'PaymentMethod'];

    function PaymentMethodDeleteController($uibModalInstance, entity, PaymentMethod) {
        var vm = this;
        vm.paymentMethod = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PaymentMethod.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
